var SpriteSymbol = require("../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/.pnpm/rspack-svg-sprite-loader@6.0.12/node_modules/rspack-svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "icon-sprite-arrow-right",
  "use": "icon-sprite-arrow-right-usage",
  "viewBox": "0 0 15 25",
  "content": "<symbol viewBox=\"0 0 15 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sprite-arrow-right\"><path d=\"M2 2l11 10.412L2.086 23\" stroke=\"#00CB93\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol